import { render, staticRenderFns } from "./OiltankManage.vue?vue&type=template&id=03e8382a&scoped=true"
import script from "./OiltankManage.vue?vue&type=script&lang=js"
export * from "./OiltankManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e8382a",
  null
  
)

export default component.exports